import { createStore } from "vuex";
import { ulsname, AuthUser } from "../project/Source/localstate";
import {
  LoadUser,
  SaveStatePlugin,
  GetSession,
  RemoveSession,
} from "../project/Source/localstate";

export default createStore({
  plugins: [SaveStatePlugin],
  state: {
    user: null,
  },
  mutations: {
    LOGOUT_USER(state) {
      state.user = null;
      localStorage.removeItem(ulsname);
    },
    initialiseStore(state) {
      let user = LoadUser();
      if (user && GetSession()) {
        state.user = user;
      } else {
        state.user = null;
      }
    },
    setUser(state, user) {
      state.user = user;
    },
  },
  actions: {
    logout({ commit }) {
      commit("LOGOUT_USER");
      localStorage.removeItem('session'); 
      RemoveSession(); 
    },
    login({ commit }, user) {
      AuthUser(user);
      commit("setUser", user);
    }
  },
  getters: {
    isAuthenticated: (state) => !!state.user,
    isAdmin: (state) => state.user && [9, 10, 11, 12].includes(state.user.roleId),
    isWorker: (state) => state.user && [1, 2, 3].includes(state.user.roleId),
    userRole: (state) => (state.user ? state.user.roleId : null),
    userName: (state) => (state.user ? state.user.fullName : "")
  },

});